<template>
  <div class="menu-pases" :class="{ 'is-open': isOpen }">
    <div class="button-alike" v-show="showConfirm">¿Estás seguro que deseas anular el pase?</div>
    <Button v-show="showConfirm" type="button" text="Confirmar" classtype="grouped-bottom" @click="anularPase" />
    <Button v-show="!showConfirm" type="button" text="Anular pase" classtype="grouped-up" @click="askAnularPase" />
    <Button v-show="!showConfirm" type="button" text="Modificar pase" classtype="grouped-bottom" @click="editPase" />
    <Button class="mt-20 mb-80" type="button" text="Cerrar" classtype="back" @click="close" />
  </div>
</template>
<script setup>
import { ref } from "vue"
import Button from "../components/Button.vue"
defineProps({
  isOpen: {
    type: Boolean,
    default: false,
  },
})

const showConfirm = ref(false)

const askAnularPase = () => {
  showConfirm.value = true
}

const emit = defineEmits({ close: String, edit: String, anular: String })
const close = () => {
  showConfirm.value = false
  emit("close")
}

const editPase = () => {
  emit("edit")
}

const anularPase = () => {
  emit("anular")
}
</script>
<style>
.button-alike {
  border-radius: 18px;
  text-align: center;
  font: normal normal medium 17px/21px Proxima Nova;
  letter-spacing: 0px;
  font-size: 1.1rem;
  min-width: 300px;
  height: 60px;
  max-width: 300px; /* TODO: to check */
  color: #075eb0;
  background-color: #ffffff;
  border-radius: 15px 15px 0 0;
  border: none;
  display: flex;
  justify-content: center;
  align-content: center;
  flex-direction: column;
}

.menu-pases {
  position: fixed;
  top: 0;
  min-height: 100vh;
  width: 100%;
  transform: translateX(-101%);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  transition: transform 0.5s ease-in-out;
  align-items: center;
  left: 0;
  background-color: #03182ec3;
  z-index: 1;
  padding-bottom: 4%; /* TODO: chanchada pa revisar */
}

.menu-pases li {
  font-size: 1.1rem;
  font-weight: 500;
  list-style-type: none;
  color: #fff;
  margin-top: 40px;
}

.menu-pases button {
  min-width: 300px;
}

.is-open {
  transform: translate(0);
}
</style>
